import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { OrderLookupBody } from "../components/OrderLookupBody";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: Immutable<templates.OrderLookupDocumentTemplate>,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <OrderLookupBody {...props} />
    </PageSkeleton>
);
